const LISTING_COMPONENT_GROUP_NAME = {
  ADDRESS: 'Address',
  AMENITIES: 'Amenities',
  CONTACT_INFO: 'ContactInfo',
  DETAILS_DESCRIPTION: 'DetailsDescription',
  BUILDING_DETAILS: 'BuildingDetails',
} as const;

const AnalyticsConstants = {
  LISTING_COMPONENT_GROUP_NAME,
};

export default AnalyticsConstants;
